import React, { useState, useEffect, useRef } from "react";

import {
  ProfileIcon,
  ChatBotIcon,
  LeftArrow_icon,
  Robo_icon,
  Send_icon,
} from "assets/images";

const ChatbotPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Hi! Ask me anything", sender: "bot" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [position, setPosition] = useState({ x: 20, y: 20 });
  const user = JSON.parse(localStorage.getItem("user"));

  // Toggle Chat
  const toggleChat = () => setIsOpen((prev) => !prev);

  // Send Message
  const handleSend = async () => {
    if (!input.trim()) return;
    const userMessage = { text: input, sender: "user" };
    const updatedMessages = [...messages, userMessage];
    setMessages(updatedMessages);
    setInput("");
    setLoading(true);

    try {
      const previous = updatedMessages.slice(0, -1).map((msg) => ({
        role: msg.sender === "bot" ? "assistant" : "user",
        content: msg.text,
      }));

      const response = await fetch(
        "https://dev-api.hsiheadwalls.com/user/chatBot",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ prompt: input, previous }),
        }
      );

      const data = await response.json();
      const reply =
        data?.choices?.[0]?.message?.content ||
        data?.answer ||
        "Sorry, I couldn't respond.";

      setMessages((prev) => [...prev, { text: reply, sender: "bot" }]);
    } catch (error) {
      console.error("❌ Chatbot error:", error);
      setMessages((prev) => [
        ...prev,
        { text: "Something went wrong. Try again later.", sender: "bot" },
      ]);
    }

    setLoading(false);
  };

  const renderTextWithLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#2F80ED",
              textDecoration: "underline",
              wordBreak: "break-word", // ✅ specifically for links
              overflowWrap: "anywhere",
            }}
          >
            {part}
          </a>
        );
      }
      return part; // Normal text
    });
  };

  const messagesEndRef = useRef(null);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSend();
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <>
      {/* Floating Button */}
      {!isOpen && (
     <button
  onClick={toggleChat}
  style={{
    position: "fixed",
    bottom: "60px",
    right: "20px",
    width: "85px",
    height: "85px",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    overflow: "hidden",     // ✅ ensures clickable area is only circular
    clipPath: "circle(50%)" // ✅ restricts hover/click area to circle
  }}
>
  <img
    src={ChatBotIcon}
    alt="Chatbot Icon"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "contain",
      pointerEvents: "none" // ✅ ensures only button handles clicks, not img
    }}
  />
</button>
      )}

      {/* Popup Chat Window */}

      {/* Chat Popup */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: "0px",
            right: "20px",
            transform: position.y < 150 ? "none" : "translateY(0%)",
            width: "350px",
            height: "500px",
            borderRadius: "10px",
            boxShadow: "0 0 15px rgba(0,0,0,0.2)",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            zIndex: 999,
          }}
        >
          {/* Header */}
          <div style={styles.header}>
            <span style={styles.backArrow} onClick={toggleChat}>
              <img src={LeftArrow_icon} alt="Arrow Icon" />
            </span>
            <strong>Chatbot</strong>
          </div>

          {/* Messages */}
          <div style={styles.messages}>
            {messages.map((msg, idx) => (
              <div
                ref={messagesEndRef}
                key={idx}
                style={{
                  ...styles.messageContainer,
                  flexDirection: msg.sender === "user" ? "row-reverse" : "row",
                }}
              >
                <div style={styles.avatar}>
                  {msg.sender === "bot" ? (
                    <img src={Robo_icon} alt="bot" style={styles.avatarImg} />
                  ) : (
                    <div className="rounded-full border border-slate-200 cursor-pointer flex w-12 h-12 float-right overflow-hidden">
                      {user ? (
                        <b className="flex items-center justify-center w-full bg-[#FFE8C9] uppercase">
                          {user?.first_name?.charAt(0)}
                          {user?.last_name?.charAt(0)}
                        </b>
                      ) : (
                        <img
                          src={ProfileIcon}
                          alt="img"
                          className="w-full h-full object-cover "
                        />
                      )}
                    </div>
                  )}
                </div>
                <div style={styles.messageBox}>
                  {/* <div style={styles.name}>
                    {msg.sender === "bot" ? "Chatbot" : "You"}
                  </div> */}
                  <div style={styles.bubble}>
                    {renderTextWithLinks(msg.text)}
                  </div>
                </div>
              </div>
            ))}
            {loading && (
              <div style={styles.messageContainer}>
                <div style={styles.avatar}>
                  <img src={Robo_icon} alt="bot" style={styles.avatarImg} />
                </div>
                <div style={styles.messageBox}>
                  <div style={styles.name}>Chatbot</div>
                  <div style={styles.bubble}>Typing...</div>
                </div>
              </div>
            )}
          </div>
          {/* Input */}
          <div style={styles.inputArea}>
            <input
              autoFocus={isOpen}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Write a message"
              style={styles.input}
            />
            <button onClick={handleSend} style={styles.sendBtn}>
              <img src={Send_icon} alt="Send Icon" />
            </button>
          </div>
        </div>
      )}
    </>
  );
};

const styles = {
  header: {
    padding: "15px",
    fontWeight: "bold",
    borderBottom: "1px solid #eee",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  backArrow: {
    cursor: "pointer",
    fontSize: "18px",
  },
  messages: {
    flex: 1,
    padding: "10px",
    overflowY: "auto",
    backgroundColor: "#F9F9F9",
  },
  messageContainer: {
    display: "flex",
    alignItems: "flex-start",
    marginBottom: "10px",
  },
  avatar: {
    width: "40px",
    height: "40px",
  },
  avatarImg: {
    borderRadius: "50%",
  },
  messageBox: {
    maxWidth: "250px",
    marginLeft: "10px",
    marginRight: "10px",
  },
  name: {
    fontSize: "12px",
    marginBottom: "4px",
    color: "#333",
  },
  bubble: {
    backgroundColor: "#f1f1f1",
    padding: "10px",
    borderRadius: "10px",
    fontSize: "14px",
  },
  inputArea: {
    display: "flex",
    border: "2px solid #eee",
    borderRadius: "8px",
    margin: 20,
  },
  input: {
    flex: 1,
    padding: "10px",
  },
  sendBtn: {
    marginLeft: "10px",
    padding: "10px",
    fontSize: "18px",
    color: "white",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
};
export default ChatbotPopup;
